import React from 'react';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function MouseMove({ action, variables, setOpenVariable }) {
    return (
        <>
            <div className="form-element">
                X : <TextInput action={action} inputName="x" variables={variables}
                    setOpenVariable={setOpenVariable} filter="string" disabled />
            </div>
            <div className="form-element">
                Y : <TextInput action={action} inputName="y" variables={variables}
                    setOpenVariable={setOpenVariable} filter="string" disabled />
            </div>
            {action.fields.image?.byteValue && <img src={`data:image/jpeg;base64,${action.fields.image.byteValue}`} alt="autommate_mousemove" />}
        </>
    );
}
export default MouseMove;